import http from "../helpers/http-common"

class ScoreService {

    search(params) {
        return http.post(`/score/search`, params);
    }

    getStats(params) {
        return http.post(`/score/stats`, params);
    }

    getList(params) {
        return http.post(`/score/list`, params);
    }

    getUserHistory(params) {
        return http.post(`/score/user-history`, params);
    }
}

export default new ScoreService();
